var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", [
      _c("p", [_vm._v(_vm._s(_vm.o.id))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.printDate(_vm.o.report_date)))]),
    ]),
    _vm._v(" "),
    _c(
      "td",
      _vm._l(_vm.o.details, function (d) {
        return _c("p", [
          _vm._v(_vm._s(d.drug.title) + " x "),
          _c("strong", [_vm._v(_vm._s(d.qty))]),
          _vm._v(" x\n      "),
          _c("strong", [_vm._v(_vm._s(d.price))]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("td", [
      _c("p", [
        _vm._v("Заявка: "),
        _c("strong", [_vm._v(_vm._s(_vm.o.price))]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Доставка: "),
        _c("strong", [_vm._v(_vm._s(_vm.o.delivery_price))]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Скидка: "),
        _c("strong", [
          _vm._v(
            _vm._s(_vm.o.discount_type === 1 ? "%" : "") +
              _vm._s(_vm.o.discount)
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "td",
      _vm._l(_vm.ordersChanges[_vm.o.id].details, function (d) {
        return _c("p", [
          _vm._v(_vm._s(d.drug.title) + " x "),
          _c("strong", [_vm._v(_vm._s(d.qty))]),
          _vm._v(" x\n      "),
          _c("strong", [_vm._v(_vm._s(d.price))]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("td", [
      _c("p", [
        _vm._v("Заявка: "),
        _c("strong", [
          _vm._v(_vm._s(_vm.ordersChanges[_vm.o.id].orderFinance.price)),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Доставка: "),
        _c("strong", [
          _vm._v(
            _vm._s(_vm.ordersChanges[_vm.o.id].orderFinance.delivery_price)
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Скидка: "),
        _c("strong", [
          _vm._v(_vm._s(_vm.ordersChanges[_vm.o.id].orderFinance.discount)),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-info",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.updateOrders(_vm.o.id)
            },
          },
        },
        [_vm._v("Выбрать")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }